import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import CostAnalytics from '../components/CostAnalytics';
import MetricInfoButton from '../components/MetricInfoButton';

const CostAnalyticsPage = () => {
  return (
    <div className="space-y-6">
      {/* Header with Back Button */}
      <div className="bg-white -m-6 p-6 shadow-sm">
        <div className="flex justify-between items-center">
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold text-gray-900">Cost Analytics</h1>
              <MetricInfoButton metricType="cost-analytics" />
            </div>
            <p className="text-gray-600 text-sm">Monitor API usage costs and spending patterns</p>
          </div>
          <Link 
            to="/" 
            className="bg-blue-600 text-white px-4 py-2 rounded-md flex items-center hover:bg-blue-700 transition-colors"
          >
            <FaArrowLeft className="mr-2" />
            Back to Dashboard
          </Link>
        </div>
      </div>
      
      <CostAnalytics />
    </div>
  );
};

export default CostAnalyticsPage; 